import { IModuleInitializerParams } from "@/Common/Modularity/ModuleInitializer";
import { ModuleInitializerBuilder } from "@/Common/Modularity/ModuleInitializerBuilder";
import { ModuleNames } from "../ModuleNames";

function isOacisLaunchPilotUser(params: IModuleInitializerParams): boolean {
    return params.clinicSettings
        && typeof params.clinicSettings.OacisContextualLaunchPilotUsers === "string"
        && params.clinicSettings.OacisContextualLaunchPilotUsers.split(",").includes(params.currentEmployee.ContactFacetId.toUpperCase());
}

function isFeatureFlagEnabled(params: IModuleInitializerParams): boolean {
    return params.clinicSettings?.EnableOacisContextualLaunch === true;
}

function shouldLoadOacisModule(params: IModuleInitializerParams): boolean {
    return isFeatureFlagEnabled(params) || isOacisLaunchPilotUser(params);
}

const initializeOacis = new ModuleInitializerBuilder()
    .withConditionalLoading(shouldLoadOacisModule)
    .build(ModuleNames.Oacis, async () => (await import("./OacisModule")).default);

export default initializeOacis;
